"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Slider_1 = __importDefault(require("@mui/material/Slider"));
var system_1 = require("@mui/system");
function valueLabelFormat(value) {
    return value.toLocaleString();
}
function calculateValue(value) {
    return value;
}
var Slider = function (_a) {
    var onChange = _a.onChange, value = _a.value, maxTrades = _a.maxTrades, _b = _a.className, className = _b === void 0 ? "" : _b;
    var handleChange = function (_event, newValue) {
        if (typeof newValue === "number") {
            onChange(newValue);
        }
    };
    return ((0, jsx_runtime_1.jsx)(StyledSlider, { value: value, min: 1, step: 1, 
        // marks={getMarks(maxTrades)}
        max: maxTrades, scale: calculateValue, getAriaValueText: valueLabelFormat, valueLabelFormat: valueLabelFormat, onChange: handleChange, valueLabelDisplay: "auto", className: "twap-slider ".concat(className) }));
};
exports.default = Slider;
var StyledSlider = (0, system_1.styled)(Slider_1.default)({
    "& .MuiSlider-markLabel": {
        maxWidth: 50,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});
